<div class="select-container multi-select-expand-search" [class.expanded]="searchVisible">
  <div
    class="chips-container"
    cdkOverlayOrigin
    #trigger="cdkOverlayOrigin"
    #triggerElement
    (click)="toggleSearchVisibility()"
  >
    <ng-content></ng-content>
    <span class="select-arrow cta-btn" [class.open]="searchVisible" [inlineSVG]="'/icons/icon-arrow-down.svg'"></span>
  </div>
</div>

<!-- In an overlay, not in the page flow: the filter bar it sits in is `position: sticky`, so an
absolutely positioned panel hangs off the bottom of the screen with no way to scroll to it. -->
<ng-template
  cdkConnectedOverlay
  cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
  [cdkConnectedOverlayOrigin]="trigger"
  [cdkConnectedOverlayOpen]="searchVisible"
  [cdkConnectedOverlayPositions]="overlayPositions"
  [cdkConnectedOverlayWidth]="panelWidth"
  [cdkConnectedOverlayViewportMargin]="VIEWPORT_MARGIN"
  [cdkConnectedOverlayPush]="true"
  [cdkConnectedOverlayHasBackdrop]="true"
  (backdropClick)="close()"
  (detach)="close()"
  (overlayKeydown)="onOverlayKeydown($event)"
>
  <div class="search-panel" [style.max-height.px]="panelMaxHeight">
    <div class="input-container">
      <span class="icon icon-search" [inlineSVG]="'/icons/icon-search.svg'"></span>
      <input
        class="search-input"
        type="text"
        [placeholder]="placeholder"
        [formControl]="showInput"
        #showInputElement
        (keyup)="searchShows($event)"
      />
    </div>

    <div class="options-container" (scroll)="onOptionsScroll($event)">
      @if (grouped) {
        @for (group of groups; track trackByGroupKey($index, group)) {
          <div class="option-group">
            <button
              type="button"
              class="group-header"
              [attr.aria-expanded]="isGroupExpanded(group)"
              (click)="toggleGroup(group)"
            >
              <span
                class="group-chevron"
                [class.open]="isGroupExpanded(group)"
                [inlineSVG]="'/icons/icon-arrow-down.svg'"
              ></span>
              <span class="group-label">{{ group.label }}</span>
              <span class="group-count"
                ><span class="group-selected" [hidden]="!group.selectedCount">{{ group.selectedCount }}/</span
                >{{ group.count }}</span
              >
            </button>
            @if (isGroupExpanded(group)) {
              <div class="group-items">
                @if (group.loading) {
                  <div class="options-loading">
                    <mat-spinner class="primary" [diameter]="18"></mat-spinner>
                  </div>
                }
                @for (item of group.items; track item) {
                  <div class="option-content">
                    <mat-checkbox
                      class="checkbox d-block"
                      [checked]="item?.selected"
                      (change)="toggleSelection($event.checked, item)"
                    >
                      <span>{{ item.start | date: 'dd-MM-yyyy HH:mm' }}</span>
                      @if (item?.area_name) {
                        <span> - {{ item.area_name }}</span>
                      }
                    </mat-checkbox>
                  </div>
                }
              </div>
            }
          </div>
        }
      } @else {
        @for (item of filteredItems; track item) {
          <div class="option-content">
            <mat-checkbox
              class="checkbox d-block"
              [checked]="item?.selected"
              (change)="toggleSelection($event.checked, item)"
            >
              @if (!customPropertyToDisplay) {
                <span>{{ item.movie_title }} - </span>
                <span>{{ item.start | date: 'dd-MM-yyyy HH:mm' }}</span>
                <span> - {{ item?.area_name }}</span>
              } @else {
                <span>{{ item[customPropertyToDisplay] }}</span>
              }
            </mat-checkbox>
          </div>
        }
      }

      <!-- Only once something has been typed: nothing has been searched for yet on an empty box, so
          "no results" would be answering a question nobody asked. -->
      @if (emptyLabel && showInput.value && !loading && !(grouped ? groups?.length : filteredItems?.length)) {
        <div class="options-empty">
          {{ emptyLabel }}
        </div>
      }

      @if (loading) {
        <div class="options-loading">
          <mat-spinner class="primary" [diameter]="20"></mat-spinner>
        </div>
      }
    </div>
  </div>
</ng-template>
